<template>
  <div>
    <div class="merchant success login">
      <div class="cashalo-div">
        <img src="@/assets/cashalo.svg" alt="">
      </div>
      <div class="waves"></div>
      <div class="circle-right"></div>
        <div class="success-div">
          <div class="ui grid container success login-page">
            <div class="content">
              <h4>User Login</h4>
              <label v-if="invaliduser" class="invalid">{{ errormsg }}</label>
              <form class="ui form">
                <div class="field username">
                  <input
                  type="text"
                  v-model="username" placeholder="Username">
                  <!-- <label class="invalid" v-if="username">Invalid format</label> -->
                </div>
                <div class="field password">
                  <input
                  type="password"
                  v-model="password" placeholder="Password">
                  <!-- <label class="invalid" v-if="password">Invalid format</label> -->
                </div>
              </form>
            </div>
            <a v-on:click.prevent="submit"
              class="ui button orange"
              :class="{disabled: !checkSubmit(), orange: checkSubmit()}">
              OK
            </a>
          </div>
        </div>
    </div>
</div>
</template>
<script>
const axios = require('axios');
const { login } = settings
import settings from './config/settings.json';
export default {
  name:'cms-login',
  props: {
    callback: Boolean,
    logout: Boolean
  },
  data() {
    return {
      username: '',
      password: '',
      errormsg: '',
      invaliduser: false,
      loggedin: false
    }
  },
  methods: {
    async submit() {
      this.loading = true
      this.invaliduser = false
      var apiPath = `${login}`
      const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
      const params = {
        username: this.username,
        password: this.password
      }

      await axios.post(apiPath, params, { headers })
      .then( response => {
        if (response.status == 200) {
          if (response.data == false) {
            this.username = ''
            this.password = ''
            this.errormsg = "Incorrect Username or Password"
            this.invaliduser = true
            localStorage.clear()
            localStorage.setItem("loggedin", false);
            console.log(localStorage);

          } else {
            this.loading = false
            localStorage.removeItem('loggedin');
            localStorage.setItem("loggedin", true);
            this.$router.push('/cms')
            console.log(localStorage);
          }
        }
      })
      .catch( err => {
        this.username = ''
        this.password = ''
        this.errormsg = "System Error! Please Try Again Later"
        this.invaliduser = true
      })
    },

    checkSubmit() {
      if(!this.username){return false}
      if(!this.password){return false}
      return true
    }
  },
  mounted() {
    console.log(localStorage);
    localStorage.clear()
  }
}
</script>
